const {registerModule} = window;

class Form {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUi();
    this.setVars();
    setTimeout(() => {
      this.ui.$loader.remove();
      this.loadForm();
    }, 600);
  }

  unmount() {}

  bindUi() {
    this.ui = {};
    this.ui.$form = this.element.querySelector('[data-ref="form-form"]');
    this.ui.$loader = this.element.querySelector('[data-ref="form-loader"]');
    this.ui.$successMessage = this.element.querySelector('[data-ref="form-success-message"]');
  }

  watchForMarketoErrorMessage() {
    // Use a MutationObserver to determine if an additional Marketo error was shown after submission and scroll that error into view
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        // This fires when MutationObserver detects a change on this.element (the form module HTML)
        const errorMessageIfExists = mutation.target.querySelector('.mktoErrorMsg');

        if (errorMessageIfExists) {
          // If an error message was added by Marketo (detected via MutationObserver) scroll the form field into view
          console.log('Attempting to scroll to Marketo-returned error.');
          mutation.target.querySelector('.mktoField').scrollIntoView({block: 'center'});
          mutation.target.querySelector('.mktoError').setAttribute('data-custom-marketo-error', '');
        }
      }
    };

    this.errorMessageObserver = new MutationObserver(callback);

    this.errorMessageObserver.observe(this.element, {childList: true, subtree: true});
  }

  loadForm() {
    if (!window.MktoForms2) {
      return;
    }

    window.MktoForms2.loadForm(`//${this.hostname}`, this.munchkinId, this.formId);

    window.MktoForms2.whenReady((form) => {
      // Only proceed if the submitted form ID matches this module's form,
      // in the case of multiple forms on a single page.
      if (form.getId().toString() === this.formId) {
        // All <form> elements are hidden by default to remove them from the
        // accessibility tree. If the script successfully initializes, remove
        // the hidden attribute to make it available in all contexts.
        this.ui.$form.removeAttribute('hidden');

        form.onSubmit(() => {
          try {
          // Attempt to disconnect any previous MutationObserver listening to Marketo errors
            if ('errorMessageObserver' in this) {
              this.errorMessageObserver.disconnect();
            }
            // Start observing the form after the user attempts a submission
            this.watchForMarketoErrorMessage();
          } catch (error) {
            console.log('Error detecting Marketo server error - onSubmit', error);
          }
        });


        form.onSuccess((formEl) => {
          // FormComplete form submission tracking fix. Place this within the onSuccess callback for Marketo.
          try {
            const MarketoToMappingID = {
              // Add Marketo form id (just number) and the FormComplete mapping ID. Instructions on how to get the mapping IP in email.
              1038: '6220d24b-4563-4f98-828f-cf452194c286',
            };
            MarketoToMappingID[formEl.formid] && window._zi_fc.fcTriggerSubmit(MarketoToMappingID[formEl.formid]);
          } catch (err) {
            console.log('ZoomInfo trigger failed', err);
          }

          // Other onSuccess logic below

          try {
            // Attempt to scroll to the form element so the confirmation is visible
            if (!this.storybuilder) {
              // Remove confirmation scrolling on Storybuilder because it redirects to the Storybuilder app
              document.getElementById('mktoForm_' + formEl.formid).scrollIntoView();
            }
          } catch (error) {
            /* eslint-disable-next-line no-console */
            console.log('Scroll to element failed.');
          }

          if (formEl.formid === this.formId) {
            // LinkedIn InsightTag event tracking
            if (this.lintrkConversionId && window.lintrk) {
              /* eslint-disable-next-line camelcase */
              window.lintrk('track', {conversion_id: this.lintrkConversionId});
            }

            // Microsoft/Bing UET event tracking
            if (this.msuetEventName) {
              window.uetq = window.uetq || [];
              window.uetq.push('event', this.msuetEventName, {});
            }

            // Redirect (and populate) the storybuilder app if applicable
            if (this.storybuilder) {
              window.setTimeout(function() {
                // This has a 200ms delay to help fix a bug in GTM that causes the tag to be "Still running"
                const vals = form.vals();
                const email = encodeURIComponent(vals.Email);
                const utmSource = vals.UTM_Source__c ? '&utm_source=' + vals.UTM_Source__c : '';
                const utmTerm = vals.UTM_Term__c ? '&utm_term=' + vals.UTM_Term__c : '';
                const utmMedium = vals.uTMMedium ? '&utm_medium=' + vals.uTMMedium : '';
                const utmCampaign = vals.uTMCampaign ? '&utm_campaign=' + vals.uTMCampaign : '';
                const firstName = vals.FirstName ? '&first_name=' + encodeURIComponent(vals.FirstName) : '';
                const lastName = vals.LastName ? '&last_name=' + encodeURIComponent(vals.LastName) : '';
                location.href = 'https://app.storybuilder.everlaw.com/users/signup.do#email=' + email + utmSource + utmTerm + utmMedium + utmCampaign + firstName + lastName;
              }, 200);


              // Prevent default redirect or page reload
              return false;
            }

            // Hide the form and display a success message
            if (this.showSuccessMessage) {
              this.ui.$form.setAttribute('hidden', true);
              this.ui.$successMessage.removeAttribute('hidden');

              // Prevent default redirect or page reload
              return false;
            }

            // TODO: Detect a gate variant here to fire this
            const marketoFormSubmitEvent = new CustomEvent('marketoFormSubmitEvent', {
              detail: {
                formInstance: this,
              },
              bubbles: true,
            });
            this.element.dispatchEvent(marketoFormSubmitEvent);
            return false;
          }

          try {
            if ('errorMessageObserver' in this) {
              // Disconnect the MutationObserver after a successful submission, if one exists
              this.errorMessageObserver.disconnect();
            }
          } catch (error) {
            console.log('Error detecting Marketo server error - onSuccess', error);
          }
        });
      }
    });
  }

  setVars() {
    this.formId = this.ui.$form.dataset.formId;
    this.hostname = this.ui.$form.dataset.hostname;
    this.lintrkConversionId = this.ui.$form.dataset.lintrkConversionId;
    this.msuetEventName = this.ui.$form.dataset.msuetEventName;
    this.munchkinId = this.ui.$form.dataset.munchkinId;
    this.storybuilder = this.ui.$form.dataset.storybuilder;
    this.showSuccessMessage = this.ui.$successMessage != null;
    this.modalId = this.element.dataset.modalId;
    this.cookieOnSubmit = this.ui.$form.dataset.cookieOnSubmit;
  }
}

registerModule('Form', Form);
